import React, { ReactNode } from 'react'
import { connect, DispatchProp } from 'react-redux'
import { RouteComponentProps } from '../../../helpers/withRouter'
import Select from 'react-select'
import { AnyAction } from 'redux'
import { Button, Page, Spinner } from '../../../components'
import { images } from '../../../images'
import { AuthenticatedRoutable, IServiceInfo, ISuggestionComplaint, ISuggestionType } from '../../../models'
import literalsService from '../../../services/literals-service'
import { addSuggestionAction, fetchServicesAction } from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import StyledArticle from '../ComplaintsAndSuggestions/styles'
import { appsStyleSelected } from '../../../helpers/app'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  serviceInfos: IServiceInfo[]
  isLoading: boolean
}

interface IState {
  serviceId: number | null
  description: string
  descriptionError: boolean
}

class ObjectsLost extends AuthenticatedRoutable<IProps, IState> {

  constructor(props: IProps) {
    super(props)
    this.state = {
      serviceId: null,
      description: '',
      descriptionError: false
    }
  }

  private get serviceOptions() {
    const { serviceInfos } = this.props
    return serviceInfos
      .map(service => ({ value: service.id, label: service.tag }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }

  public componentDidMount(): void {
    const { dispatch, serviceInfos } = this.props
    super.componentDidMount()
    if (serviceInfos.length === 0) dispatch(fetchServicesAction())
  }

  public render(): ReactNode {
    const { isLoading } = this.props
    const { description, descriptionError } = this.state

    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
            {
              isLoading ? (
                <article className="spinner-container">
                  <Spinner />
                </article>
              ) : (
                <section>
                  <h3>{ literalsService.get('objectsLost', true) }</h3>
                  <label className="fieldLabel">{ literalsService.get('service', true) }</label>
                  <Select className="select" options={ this.serviceOptions } placeholder={ literalsService.get('select', true) } onChange={ this.handleChangeService } />
                  <label className="fieldLabel">{ literalsService.get('suggestionDescription', true) }</label>
                  <textarea
                    className={ descriptionError ? 'invalid' : '' }
                    value={ description }
                    placeholder={ literalsService.get('objectLostPlaceholder', true) }
                    onChange={ e => this.setState({ description: e.target.value }) }
                    maxLength={ 250 }
                  />
                  <Button
                    title={ literalsService.get('send', true) }
                    onPress={ this.handleSend }
                    className="sendButton"
                    filled
                    upper
                    isDisabled={ isLoading }
                  />
                </section>
              )
            }
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }

  private handleChangeService = (option: any) => {
    this.setState({ serviceId: option.value })
  }

  private handleSend = () => {
    const { dispatch } = this.props
    const { description, serviceId } = this.state

    if (!description.trim().length) {
      this.setState({ descriptionError: true })
      return
    }

    dispatch(addSuggestionAction(
      ISuggestionType.OBJECT_LOST,
      literalsService.get('object_lost'),
      ISuggestionComplaint.OBJECT_LOST,
      description,
      false,
      serviceId!
    ))
  }
}

const mapStateToProps = ({ newReservation, complaintsAndSuggestions }: IStoreState) => ({
  serviceInfos: newReservation.serviceInfos,
  isLoading: complaintsAndSuggestions.isLoading
})

export default connect(mapStateToProps)(ObjectsLost)
